import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer";
import { Eye, EyeOff } from "lucide-react";

const RegisterStaff = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("staf");
  const [password, setPassword] = useState("");
  const [password_confirmation, setPassword_confirmation] = useState("");
  const [idCard, setIdCard] = useState<File | null>(null);
  const [ktp, setKtp] = useState<File | null>(null);
  const [fotoProfile, setFotoProfile] = useState<File | null>(null);
  const [showPopup, setShowPopup] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorConfirm, setErrorConfirm] = useState("");

  const isFormValid = () => {
    return email && password && phone && idCard && ktp && role;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("email", email);
      formData.append("no_tlpn", phone);
      formData.append("role", role);
      formData.append("password", password);
      formData.append("password_confirmation", password_confirmation);
      if (idCard) formData.append("foto_idcard", idCard);
      if (ktp) formData.append("foto_ktp", ktp);
      if (fotoProfile) formData.append("foto_profile", fotoProfile);

      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/adminstaf/register`, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        throw new Error("Register gagal");
      }

      // ✅ kalau sukses, tampilkan popup / alert
      setShowPopup(true);

      // opsional: reset form
      setName("");
      setEmail("");
      setPhone("");
      setRole("staf");
      setPassword("");
      setPassword_confirmation("");
      setIdCard(null);
      setKtp(null);

      // kalau mau redirect ke login, aktifkan ini:
      // navigate("/login");
    } catch (error: any) {
      console.error(error);
      alert("Register gagal, periksa kembali input anda.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="bg-gradient-to-b from-white to-[#cfa84d] mx-auto flex justify-center min-h-screen">
        <div className="px-7 py-5 rounded-lg w-full md:mx-8 lg:mx-20 max-w-md  h-full my-auto">
          <div className="flex justify-center my-3">
            <img src="/images/pancasila.png" alt="" className="w-20 h-24" />
          </div>

          <h1 className="text-3xl md:text-4xl mt-4 mb-8 text-center font-bold text-[#cfa84d]">
            Registrasi <span className="text-gray-700">Staff</span>
          </h1>

          <form onSubmit={handleSubmit} className="flex flex-col gap-5">
            {/* Nama */}
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-semibold">Nama</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3" placeholder="Masukan Nama" />
            </div>

            {/* Email */}
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-semibold">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3" placeholder="Masukan Email" />
            </div>

            {/* No Telepon */}
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-semibold">No Telepon</label>
              <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3" placeholder="Masukan No Telepon" />
            </div>

            {/* Role */}
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-semibold">Role</label>
              <select value={role} onChange={(e) => setRole(e.target.value)} className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3 bg-white">
                <option value="admin">Admin</option>
                <option value="staf">Staf</option>
              </select>
            </div>

            {/* Password */}
            <div className="flex flex-col gap-2 relative">
              <label className="text-gray-700 font-semibold">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3 pr-10"
                placeholder="Masukan Password"
              />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-11 text-[#cfa84d]">
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            {/* Konfirmasi Password */}
            <div className="flex flex-col gap-2 relative">
              <label className="text-gray-700 font-semibold">Konfirmasi Password</label>
              <input
                type={showPassword ? "text" : "password"}
                value={password_confirmation}
                onChange={(e) => {
                  setPassword_confirmation(e.target.value);
                  if (e.target.value !== password) {
                    setErrorConfirm("Password konfirmasi belum sama");
                  } else {
                    setErrorConfirm("");
                  }
                }}
                className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-3 pr-10"
                placeholder="Masukan Konfirmasi Password"
              />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-11 text-[#cfa84d]">
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>

              {errorConfirm && <p className="text-red-500 text-sm mt-1">{errorConfirm}</p>}
            </div>

            {/* Foto Profile */}
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-semibold">Foto Profile</label>
              <input type="file" accept="image/*" onChange={(e) => setFotoProfile(e.target.files?.[0] || null)} className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-2 bg-white" />
            </div>

            {/* Foto ID Card */}
            <div className="flex flex-col gap-2">
              <label className="text-gray-700 font-semibold">Foto ID Card</label>
              <input type="file" accept="image/*" onChange={(e) => setIdCard(e.target.files?.[0] || null)} className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-2 bg-white" />
            </div>

            {/* Foto KTP */}
            <div className="flex flex-col gap-2 ">
              <label className="text-gray-700 font-semibold">Foto KTP</label>
              <input type="file" accept="image/*" onChange={(e) => setKtp(e.target.files?.[0] || null)} className="outline-none border border-[#cfa84d] rounded-lg text-gray-700 p-2 bg-white" />
            </div>

            {/* Tombol Daftar */}
            <div className="flex justify-end mt-2 ">
              <button
                type="submit"
                disabled={!isFormValid() || loading}
                className={`py-2 px-8 rounded-lg text-white text-center transition-all w-full cursor-pointer ${
                  !isFormValid() || loading ? "bg-gray-400 cursor-not-allowed" : "bg-[#cfa84d] hover:bg-white hover:text-[#cfa84d] border border-[#cfa84d]"
                }`}>
                {loading ? "Loading..." : "Daftar"}
              </button>
            </div>

            <div className="text-gray-700 text-center ">
              Sudah Punya Akun ?{" "}
              <span className="font-bold">
                <Link to={"/login"}>Login</Link>
              </span>
            </div>
          </form>
        </div>
      </div>

      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ">
          <div className="bg-white rounded-lg shadow-lg p-6 max-sm:max-w-xs max-w-md text-center">
            <div className="flex justify-center mb-3">
              <img src="/images/pancasila.png" alt="" className="w-16 h-20" />
            </div>
            <h2 className="text-lg font-bold mb-2">Registrasi Berhasil</h2>
            <p className="text-gray-600 mb-6">Silakan tunggu proses verifikasi dan konfirmasi dari admin sebelum akun Anda dapat digunakan untuk login.</p>

            <button
              onClick={() => {
                setShowPopup(false);
                navigate("/login"); // opsional redirect
              }}
              className="bg-[#cfa84d] text-white px-4 py-2 rounded hover:bg-white hover:text-[#cfa84d] border border-[#cfa84d]">
              Tutup
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default RegisterStaff;
